import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type E2nApiAuthContextValue = {
  getAccessToken: () => Promise<string | undefined>;
  user: { id: string; username: string } | undefined;
  standort: { id: string; name: string };
};

const E2nApiAuthContext = createContext<E2nApiAuthContextValue | undefined>(
  undefined,
);

export function E2nApiAuthProvider({
  value,
  children,
}: {
  value: E2nApiAuthContextValue;
  children: ReactNode;
}) {
  return (
    <E2nApiAuthContext.Provider value={value}>
      {children}
    </E2nApiAuthContext.Provider>
  );
}

export function useE2nApiAuth() {
  const context = useContext(E2nApiAuthContext);

  if (context === undefined) {
    throw new Error('useE2nApiAuth must be used within an E2nApiAuthProvider');
  }

  return context;
}
